import React, { Fragment, useState } from "react";
import { IoMdOpen } from "@hacknug/react-icons/io";
import { COLORS } from "utils/styles";
import LoadingSpinner from "components/LoadingSpinner";
import { getStripeOnboardAccountLink } from "utils/stripe";
import Analytics, { CLICK_STRIPE_COMPLETE_ONBOARD } from "utils/analytics";
import {
  useCtxReferences,
  useAccountConnectStatusProps
} from "utils/selectors";
import { useToasts } from "react-toast-notifications";
import isError from "lodash/isError";
import { getErrorMessage } from "utils/error";

const DEFAULT_CLASSES = {
  link:
    "link flex flex-row items-center justify-center link__decoration--hover color-primary pointer",
  copy: "f7 pr1"
};

const DEFAULT_COPY = "View on Stripe";

const StripeOnboardAccountLink = ({
  copy,
  customClasses,
  color = COLORS.blue,
  size = 16,
  hideCopy = false,
  hideIcon = false
}) => {
  const [loading, setLoading] = useState(false);
  const { addToast } = useToasts();
  const { resource, resourceUUID } = useCtxReferences();
  const { account, merchantAccount } = useAccountConnectStatusProps();

  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const input = {
    account: account && account.id,
    resource,
    resourceUUID,
    merchantAccountUUID: merchantAccount && merchantAccount.uuid
  };

  const getAccountLink = async () => {
    setLoading(true);
    Analytics.track(CLICK_STRIPE_COMPLETE_ONBOARD, input);
    const acccountLink = await getStripeOnboardAccountLink(input);

    if (isError(acccountLink)) {
      addToast(getErrorMessage(acccountLink), {
        appearance: "error",
        autoDismiss: true
      });
    } else {
      window.location.href = acccountLink;
    }

    setLoading(false);
  };

  return (
    <a className={classes.link} onClick={getAccountLink}>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <Fragment>
          {!hideCopy && (
            <div className={classes.copy}>{copy || DEFAULT_COPY}</div>
          )}
          {!hideIcon && (
            <div className="flex flex-shrink-0">
              <IoMdOpen color={color} size={size} />
            </div>
          )}
        </Fragment>
      )}
    </a>
  );
};

export default StripeOnboardAccountLink;
